<template>
  <div class="portfoliofilterbar">
    <div class="dis-flex">
      <!-- TODO CAMBIAR SELECTOR -->
      <brainsSelector
        v-model="userselectedportfolioid"
        :placeholder="$t('portfoliosSelector.select-portfolio') + '*'"
        :list="userportfolios"
        :list-key="'id'"
        :list-label="'portfolioName'"
        :loading="loading"
      />
      <button class="brains-type1-btn ml-1 mr-1" @click="addportfolio()">{{ $t("add") }}</button>
      <button
        class="brains-type5-btn mr-1"
        :class="{ 'brains-btn-disabled': currentAssets === undefined }"
        :disabled="currentAssets === undefined"
        @click="showfilter()"
      >
        {{ $t("filters") }}({{ current_filters !== null ? current_filters.length : 0 }})
      </button>
      <div v-if="userselectedportfolioid !== ''">
        <div class="brains-btn-download mr-1" @click="downportfolio()">
          <font-awesome-icon icon="download" /> <span>{{ $t("portfoliosSelector.download") }}</span>
        </div>
      </div>
      <div v-if="userselectedportfolioid !== ''">
        <div v-if="userselectedportfolioid !== ''" class="brains-btn-download mr-" @click="deleteportfolio()">
          <font-awesome-icon icon="trash" /> <span>{{ $t("portfoliosSelector.delete") }}</span>
        </div>
      </div>
      <div v-if="propertiesForResize.length > 0" style="display:inline-flex" class="brains-autocomplete-select ml-3">
        <brainsSelector
          v-model="selectedProperty"
          :placeholder="'Select'"
          :list="propertiesForResize"
          :list-key="'id'"
          :list-label="'name'"
          :loading="loading"
        />
        <brainsInfo>
          {{ $t('portfoliosSelector.infoAssetSelector') }}
        </brainsInfo>
      </div>
    </div>
    <modal v-model="showfilterdialog">
      <portfoliofiltercontrol ref="colconfig" />
    </modal>
    <modal ref="portuploadmod" v-model="showadddialog" class="modalupload">
      <portfolioupload ref="portupload" />
    </modal>
  </div>
</template>

<script>
import brainsSelector from '@/components/designComponents/brainsAutocomplete'
import brainsInfo from '@/components/designComponents/brainsInfo'
import modal from '@/components/designComponents/modal'
import portfoliofiltercontrol from '@/components/portfoliofiltercontrol.vue'
import portfolioupload from '@/components/portfolioupload.vue'
import { mapState } from 'vuex'
export default {
  name: 'PortfolioFilterBar',
  components: {
    brainsSelector, brainsInfo, modal, portfoliofiltercontrol, portfolioupload
  },
  data() {
    return {
      loading: false,
      userselectedportfolioid: '',
      selectedProperty: null,
      showfilterdialog: false,
      showadddialog: false
    }
  },
  computed: {
    ...mapState('portfolio', {
      userportfolios: (state) => state.userportfolios,
      currentportfolio: (state) => state.currentportfolio,
      current_filters: (state) => state.current_filters
    }),
    currentAssets: function() {
      return this.currentportfolio.id != null ? this.currentportfolio.data : undefined
    },
    propertiesForResize: {
      get() {
        var result = []
        var items = this.currentportfolio.stratsConfig
        if (!!items && !!items.areaoptions) { result = result.concat(items.areaoptions) }
        if (!!items && !!items.valueoptions) { result = result.concat(items.valueoptions) }
        return result
      }
    }
  },
  watch: {
    userselectedportfolioid: function() {
      this.loadportfolio()
    },
    selectedProperty: function() {
      var vm = this
      vm.$root.$emit('mapResizeProperty', vm.selectedProperty)
    }
  },
  created() {
    this.$root.$on('closeportfolioload', () => {
      this.showadddialog = false
    })
    this.$root.$on('openportfolioload', () => {
      this.userselectedportfolioid = this.userportfolios[this.userportfolios.length - 1].id
      this.loaduserportfolios()
    })
  },
  mounted() {
    const vm = this
    vm.loaduserportfolios()
  },
  methods: {
    loaduserportfolios() {
      var vm = this
      vm.loading = true
      vm.$store.dispatch('portfolio/getUserPortfolios').then(() => {
        vm.loading = false
      }).catch(() => {
        vm.loading = false
        vm.$message({
          message: vm.$t('portfoliosSelector.errorloadingportfolios'),
          type: 'error'
        })
      })
    },
    addportfolio() {
      this.showadddialog = true
      this.$refs.portuploadmod.maxsize()
    },
    showfilter() {
      this.showfilterdialog = true
    },
    loadportfolio() {
      var vm = this
      vm.loading = true
      vm.$loading().visible = true
      if (vm.userselectedportfolioid !== '') {
        vm.$store.dispatch('portfolio/loadportfolio', vm.userselectedportfolioid).then(() => {
          vm.loading = false
          vm.$loading().visible = false
          if (!!vm.propertiesForResize && vm.propertiesForResize.length > 0) { vm.selectedProperty = vm.propertiesForResize[0].id }
        }).catch(() => {
          vm.loading = false
          vm.$loading().visible = false
          vm.$message({
            message: vm.$t('portfoliosSelector.errorloadingportfolios'),
            type: 'error'
          })
        })
      }
    },
    downportfolio() {
      const vm = this
      vm.$store.dispatch('portfolio/DownloadPortfolio', vm.userselectedportfolioid)
        .then((response) => {
          const blob = new Blob([response], { type: 'application/octet-stream' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = vm.currentportfolio.name + '.xlsx'
          link.click()
        })
        .catch(() => {
          vm.$message({
            showClose: true,
            message: this.$t('portfoliosSelector.errordownloada'),
            type: 'error'
          })
        })
    },
    deleteportfolio() {
      const vm = this
      vm.$loading = true
      vm.$confirm(vm.$t('portfoliosSelector.suredeleteportfolio' + ': ' + vm.userportfolios.filter((item) => item.id === vm.userselectedportfolioid)[0].portfolioName + '?'), 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        vm.$store.dispatch('portfolio/DeletePortfolio', vm.userselectedportfolioid).then((response) => {
          vm.$loading = false
          vm.$message({
            showClose: true,
            message: vm.$t('portfoliosSelector.deletedportfolio') + ' ' + response.name,
            type: 'success'
          })
          document.location.reload()
        }).catch(() => {
          vm.$message({
            showClose: true,
            message: vm.$t('portfoliosSelector.errordeleting'),
            type: 'error'
          })
        })
      })
    }
  }
}
</script>

<style>
.modalupload .brains-asset-data-modal--content {
  background-color:linen !important;
  top: 50vh;
}
</style>

<style lang="scss" scoped>
.brains-autocomplete-select {
  display: flex;
  align-items: center;
  height: 32px;
  font-family: 'Montserrat-Regular',sans-serif;
  font-size: 14px;
  gap: 8px;

  .brains-autocomplete-input {
    width: 100%;
    height: 32px;
    position: relative;

    .brains-autocomplete-input-arrow-suffix {
      position: absolute;
      display: flex;
      right: 14px;
      height: 32px;
      align-items: center;
      cursor: pointer;

      .brains-autocomplete-input-arrow {
        color: lightgrey;
      }
    }

    input {
      min-width: 130px;
      width: 100%;
      height: 100%;
      padding: 0 10px;
      border: 1px solid lightgrey;
      font-family: 'Montserrat-Regular',sans-serif;
      font-size: 12px;
      outline: none;
      border-radius: 4px;
      color: rgba(0, 0, 0, 0.8);
      cursor: pointer;

      &:focus {
        outline: 1px solid #1e3cff;
      }

      &::-webkit-calendar-picker-indicator {
        display: none;
        opacity: 0;
        cursor: pointer;
        // color: lightgrey;
      }
    }
  }
}

.el-select-dropdown__item {
  border-top: 1px solid lightgray;
}

.el-select-dropdown__item {
  // height: 65px;
  border-top: 1px solid lightgray;
  height: 38px !important;
}
</style>

<style lang="scss">
</style>
